import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { OrderClient, OrderLineModel, OrderModel } from '@core/services/api.service';
import { LoadOrderHistorySuccessAction, LoadOrderHistoryFailAction, LoadOrderHistoryAction, GetOrderByIdAction, GetOrderByIdSuccessAction, GetOrderByIdFailAction, CreateOrderAction, CreateOrderSuccessAction, CreateOrderFailAction } from './order.actions';
import { Injectable } from '@angular/core';
import { ClearItemsFromCartAction, LoadCartItemsAction } from '@ngxs-store/cart/cart.actions';
import { Navigate } from '@ngxs/router-plugin';
import { OpenToastrAction } from '@ngxs-store/ui-store/ui.actions';
import { ToastrType } from '@core/models/ui/toastr-config';
export class OrderStateModel {
    public isLoading: boolean;
    public orderHistory: OrderModel[];
    public order: OrderModel;
    public errMessage: string;
}

@State<OrderStateModel>({
    name: 'order',
    defaults: {
        isLoading: false,
        orderHistory: [],
        order: new OrderModel,
        errMessage: ''
    }
})
@Injectable()
export class OrderState {
    constructor(
        private orderClient: OrderClient
    ) { }

    @Selector()
    static isLoading(state: OrderStateModel) {
        return state.isLoading;
    }

    @Selector()
    static getOrdersHistory(state: OrderStateModel) {
        return state.orderHistory;
    }

    @Selector()
    static getOrder(state: OrderStateModel) {
        return state.order;
    }

    @Action(LoadOrderHistoryAction)
    loadOrderHistoryAction({ dispatch, patchState }: StateContext<OrderStateModel>, action: LoadOrderHistoryAction) {
        patchState({ isLoading: true });

        return this.orderClient.getOrderHistory().pipe(
            tap((result) => dispatch(new LoadOrderHistorySuccessAction({ orderHistory: result }))),
            catchError((err) => dispatch(new LoadOrderHistoryFailAction()))
        );
    }

    @Action(LoadOrderHistorySuccessAction)
    loadOrderSuccessAction(ctx: StateContext<OrderStateModel>, action: LoadOrderHistorySuccessAction) {
        ctx.patchState({
            isLoading: false,
            orderHistory: action.payload.orderHistory
        });
    }

    @Action(LoadOrderHistoryFailAction)
    loadOrderFailAction(ctx: StateContext<OrderStateModel>, action: LoadOrderHistoryFailAction) {
        ctx.patchState({
            isLoading: false,
            orderHistory: []
        });
    }


    @Action(GetOrderByIdAction)
    getOrderByIdAction(ctx: StateContext<OrderStateModel>, action: GetOrderByIdAction) {
        ctx.patchState({
            isLoading: true
        });
        return this.orderClient.getOrderById(action.payload.id).pipe(
            tap((result) => ctx.dispatch(new GetOrderByIdSuccessAction({ orderByDetails: result }))),
            catchError((err) => ctx.dispatch(new GetOrderByIdSuccessAction(err))),

        );

    }

    @Action(GetOrderByIdSuccessAction)
    getOrderByIdSuccessAction(ctx: StateContext<OrderStateModel>, action: GetOrderByIdSuccessAction) {
        ctx.patchState({
            isLoading: false,
            order: action.payload.orderByDetails
        });
    }

    @Action(GetOrderByIdFailAction)
    getOrderByIdFailAction(ctx: StateContext<OrderStateModel>, action: GetOrderByIdFailAction) {
        ctx.patchState({
            isLoading: false,
            order: new OrderModel()
        });
    }


    @Action(CreateOrderAction)
    createOrderAction({ dispatch, patchState }: StateContext<OrderStateModel>, action: CreateOrderAction) {
        patchState({ isLoading: true });

        return this.orderClient.createOrder(action.payload.createOrderCommand).pipe(
            tap((result) => dispatch(new CreateOrderSuccessAction({ createOrderCommand: action.payload.createOrderCommand }))),
            catchError((err) => dispatch(new CreateOrderFailAction(err)))
        );
    }

    @Action(CreateOrderSuccessAction)
    createOrderSuccessAction(ctx: StateContext<OrderStateModel>, action: CreateOrderSuccessAction) {
        ctx.patchState({
            isLoading: false
        });
        ctx.dispatch(new ClearItemsFromCartAction());
        ctx.dispatch(new Navigate(['/products'], { category: 'home' }));
        ctx.dispatch(new OpenToastrAction({ message: 'Order has been Placed', type: ToastrType.success, title: 'Order Created' }));
    }

    @Action(CreateOrderFailAction)
    createOrderFailAction(ctx: StateContext<OrderStateModel>, action: CreateOrderFailAction) {
        ctx.patchState({

            isLoading: false,
            errMessage: action.payload.response
        });
    }
}
